import React, { Component } from "react";
import { SocialIcon } from 'react-social-icons';
import { Link } from "react-router-dom";
import { Markup } from 'interweave';

class Footer extends Component {
  render() {

    var sLink = {textDecoration:"none", color:"#464b6a"};
    var s = {width:"100%", height:"120px",  margin:"0px 0px 0px 0px", border:"0px dashed red"}; 
    var sOne = {width:"80%", textAlign:"center", margin:"30px 10% 20px 10%"};
    return (
        <div className="leftblock" style={s}>
            <div className="leftblock" style={sOne}>
                <img src="/imglib/unnamed-2@2x.png" style={{height:"80px"}}/>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <img src="/imglib/unnamed-1@2x.png" style={{height:"80px"}}/>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <img src="/imglib/unnamed2@2x.png" style={{height:"80px"}}/>
            </div>
        </div>
    );




  }
}

export default Footer;
